var _rect, _line, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDebitcard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 18,
    viewBox: "0 0 28 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.19531,
    y: 0.608887,
    width: 25.8042,
    height: 16.7823,
    rx: 2.5,
    stroke: "#888B94"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.25,
    y1: 6.75,
    x2: 27.5,
    y2: 6.75,
    stroke: "#888B94"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 13.25,
    width: 4.25,
    height: 1,
    rx: 0.5,
    fill: "#888B94"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.84766,
    y: 13.25,
    width: 4.25,
    height: 1,
    rx: 0.5,
    fill: "#888B94"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebitcard);
export default __webpack_public_path__ + "static/media/debitcard.076ed418b05e1ec5fdd17dad45c4dff3.svg";
export { ForwardRef as ReactComponent };